export const wellKnownKycSessionRoutes = {
  Initiation: 'Initiation',
  Region: 'Region',
  Consent: 'Consent',
  Contact: 'Contact',
  Spending: 'Spending',
  Address: 'Address',
  ProofOfAddress: 'ProofOfAddress',
  Scans: 'Scans',
  Review: 'Review',
  PendingReview: 'Pending',
  Success: 'Success',
  Failed: 'Failed',
};

type ValueOf<T> = T[keyof T];
export type WellKnownKycSessionRoute = ValueOf<typeof wellKnownKycSessionRoutes>;
